import React, { useEffect, useState } from "react";
import { Button, Offcanvas, OverlayTrigger, Tooltip } from "react-bootstrap";

import { AddOutlined, ModeEditOutlined, DeleteForeverOutlined } from "@mui/icons-material";

import useFooter from "../../hooks/useFooter";
import { toast } from "react-hot-toast";
import { idGenerator } from "../../helpers/idGenerator";

const SidebarFooter = ({ isEdit, itemsToEdit = null }) => {
  const { createFooterCat, updateFooterCat } = useFooter();
  const [showEditSlide, setShowEditSlide] = useState(false);

  const handleCloseSlide = () => setShowEditSlide(false);
  const handleShowSlide = () => setShowEditSlide(!showEditSlide);

  const [categorySelected, setCategorySelected] = useState({});

  useEffect(() => {
    setCategorySelected(itemsToEdit);
  }, [itemsToEdit]);

  const handleCategoryInput = ({ target }) => {
    setCategorySelected({
      ...categorySelected,
      [target.name]: target.value
    });
  };

  const handleDeleteLinks = (id) => {
    setCategorySelected({
      ...categorySelected,
      items: categorySelected?.items?.filter((item, i) => item?._id !== id)
    });
  };

  const handleLinksInput = ({ target }) => {
    setCategorySelected({
      ...categorySelected,
      items: categorySelected.items?.map((item, i) => {
        if (i === Number(target.id)) {
          return { ...item, [target.name]: target.value };
        }
        return item;
      })
    });
  };

  const handleAddLinks = () => {
    isEdit
      ? setCategorySelected({
          ...categorySelected,
          items: [...categorySelected?.items, { label: "", link: "", _id: idGenerator(12) }]
        })
      : setCategorySelected({
          ...categorySelected,
          items: [
            ...(categorySelected?.items ? categorySelected?.items : ""),
            { label: "", link: "", _id: idGenerator(12) }
          ]
        });
  };

  const handleSubmit = (e) => {
    e?.preventDefault();

    if (categorySelected.hasOwnProperty("_id")) {
      updateFooterCat(categorySelected).then((res) => {
        toast.success("Se guardó la categoría de Footer y sus links");
        window.location.reload();
      });
    } else {
      createFooterCat(categorySelected).then((res) => {
        toast.success("Se creó la categoría de Footer y sus links");
        window.location.reload();
      });
    }
  };

  return (
    <>
      <div className="pgi__sidebar-slides">
        <>
          <OverlayTrigger
            key="1"
            placement="top"
            overlay={
              <Tooltip id="1">{isEdit ? "Editar Categoría de links" : "Nueva Categoría"}</Tooltip>
            }
          >
            <Button className="btn-form-pgi" variant="light" onClick={handleShowSlide}>
              {isEdit ? <ModeEditOutlined /> : <AddOutlined />}
            </Button>
          </OverlayTrigger>
        </>

        <Offcanvas
          show={showEditSlide}
          onHide={handleCloseSlide}
          className="basePgi__pgi  pgi__sidebar-container"
          placement="end"
          scroll="false"
          backdrop={false}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              Footer / {isEdit ? <b>EDITAR CATEGORÍA DE LINKS</b> : <b>CREAR CATEGORÍA DE LINKS</b>}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <form className="basePgi__vista-edit-gral" onSubmit={handleSubmit}>
              <button type="submit" className="settings_button-pleno float-end botton-save-pgi">
                GUARDAR
              </button>
              <div className="input-group my-2" key={itemsToEdit?._id}>
                <small className="d-block w-100">Nombre de la categoría</small>
                <input
                  type="text"
                  className="form-control"
                  name={`category`}
                  placeholder="Ingrese el nombre"
                  id={itemsToEdit?._id}
                  defaultValue={itemsToEdit?.category}
                  onChange={handleCategoryInput}
                  maxLength={90}
                  minLength={2}
                  required
                />
              </div>
              <fieldset className="pgi__sidebar-container-items">
                <p className="basePgi__comments">
                  El nombre de la categoría es el título del grupo de links. Desde aquí podrá cargar
                  cada ítem (link) para la categoría del Footer.
                </p>
                <div className="pgi__archivo pgi__install">
                  {categorySelected?.items?.map((item, i) => {
                    return (
                      <div className="mx-3">
                        <label htmlFor="title">{i + 1}</label>
                        <OverlayTrigger
                          key="1"
                          placement="top"
                          overlay={<Tooltip id="1">Eliminar</Tooltip>}
                        >
                          <Button onClick={() => handleDeleteLinks(item?._id)}>
                            <DeleteForeverOutlined />
                          </Button>
                        </OverlayTrigger>
                        <fieldset className="pgi__sidebar-container-items form-group">
                          <div className="form-floating footer-field">
                            <input
                              type="text"
                              className="form-control"
                              name={`label`}
                              placeholder="Etiqueta"
                              id={i}
                              defaultValue={item?.label}
                              onChange={handleLinksInput}
                              maxLength={180}
                              minLength={2}
                              required
                            />
                            <label className="field-label" htmlFor={i}>
                              Escriba la etiqueta del link
                            </label>
                            <p className="basePgi__comments">
                              <span>Texto con el que se mostrará el link</span>
                            </p>
                          </div>
                          <div className="form-floating footer-field">
                            <input
                              type="text"
                              className="form-control"
                              name={`link`}
                              placeholder="Link"
                              id={i}
                              defaultValue={item?.link}
                              onChange={handleLinksInput}
                              maxLength={180}
                              minLength={2}
                              required
                            />
                            <label className="py-0 mb-1 field-label" htmlFor={i}>
                              Escriba el contenido del link
                            </label>
                            <p className="basePgi__comments">
                              <span>Ejemplo: /donde-comprar</span>
                            </p>
                            <p className="basePgi__comments">
                              <span>
                                Ejemplo: https://www.youtube.com/channel/UCs2eaZaC-7SNPcrbm1o2LDA
                              </span>
                            </p>
                          </div>
                        </fieldset>
                      </div>
                    );
                  })}
                </div>
                <OverlayTrigger
                  key="1"
                  placement="top"
                  overlay={<Tooltip id="1">Nuevo Link</Tooltip>}
                >
                  <Button variant="light" className="btn-form-pgi allW" onClick={handleAddLinks}>
                    <AddOutlined />
                  </Button>
                </OverlayTrigger>
              </fieldset>
            </form>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default SidebarFooter;
